/**
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import './safari-warning.scss';

export const SafariWarning: React.FC = () => {
  return (
    <div className="browser-warning">
      <div className="browser-logo">
        <img src="/jarvis_logo.png" alt="JARViS Logo" />
      </div>
      <div className="browser-warning-content">
        <div className="warning-icon">⚠️</div>
        <h1>Browser Not Supported</h1>
        <p>
          JAR-ViS requires Google Chrome or Microsoft Edge to function properly.
        </p>
        <p>
          Safari and Firefox are not supported due to limited WebRTC and Audio Worklet capabilities.
        </p>
        <p className="ios-note">
          <strong>iOS Users:</strong> Please use the Chrome browser app (not Safari) for the best experience.
        </p>
        <div className="browser-options">
          <div className="browser-option">
            <div className="browser-icon">🌐</div>
            <div className="browser-info">
              <h3>Google Chrome</h3>
              <p>Recommended (including iOS)</p>
            </div>
          </div>
          <div className="browser-option">
            <div className="browser-icon">📘</div>
            <div className="browser-info">
              <h3>Microsoft Edge</h3>
              <p>Also supported</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};